import { createAsyncThunk } from '@reduxjs/toolkit'
import { toastr } from 'react-redux-toastr'

import * as api from 'connections/restApi'

export const editnoofbooktobeutilized = createAsyncThunk(
  'editnoofbooktobeutilized/post',
  async (params, { rejectWithValue }) => {
    try {
      await api.editNoOfBookToBeutilized(params)
      return { success: true }
    } catch (error) {
      console.log('error', error)
      toastr.error('', error.Message)
      return rejectWithValue(error.Message)
    }
  }
)
